import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../components/ui/sheet";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { ExternalLink } from "lucide-react";

export default function ArtistDrawer(props) {
  const { open, onClose, loading, detail, canCost, nav, artId } = props;
  
  if (!open) return null;
  
  function fmtHrs(h) { return h == null ? "—" : h.toLocaleString() + "h"; }
  function fmtCurr(v) { return v == null ? "—" : "$" + v.toLocaleString(); }
  
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader className="mb-4">
          <SheetTitle>{loading ? "Loading..." : detail?.artist_name || "Artist"}</SheetTitle>
        </SheetHeader>
        
        {/* View Full Workload Button */}
        {!loading && artId && (
          <Button
            variant="outline"
            className="w-full mb-4 gap-2"
            onClick={() => nav(`/studio/resources/${artId}?tab=workload`)}
          >
            <ExternalLink className="w-4 h-4" />
            View Full Workload
          </Button>
        )}
        
        {loading && (
          <div className="h-[200px] flex items-center justify-center">
            <div className="animate-spin w-6 h-6 border-2 border-primary border-t-transparent rounded-full" />
          </div>
        )}
        
        {!loading && detail && (
          <div className="space-y-4">
            <Card className="bg-muted/30">
              <CardContent className="p-3">
                <p className="text-xs text-muted-foreground">Allocated Hours</p>
                <p className="text-xl font-light">{fmtHrs(detail.summary?.allocated_hours)}</p>
              </CardContent>
            </Card>
            
            {canCost && (
              <Card className="bg-muted/30">
                <CardContent className="p-3">
                  <p className="text-xs text-muted-foreground">Allocated Cost</p>
                  <p className="text-xl font-light">{fmtCurr(detail.summary?.allocated_cost)}</p>
                </CardContent>
              </Card>
            )}
            
            <div>
              <h3 className="text-sm font-medium text-muted-foreground mb-2">Programs</h3>
              {detail.programs?.length === 0 && (
                <p className="text-sm text-muted-foreground">No allocations</p>
              )}
              {detail.programs?.map(function(p) {
                return (
                  <Card key={p.program_id} className="mb-2 cursor-pointer" onClick={function() { nav("/programs/" + p.program_id); }}>
                    <CardContent className="p-3">
                      <p className="font-medium text-sm">{p.program_name}</p>
                      <p className="text-xs text-muted-foreground">{fmtHrs(p.allocated_hours)}</p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
